<div *ngIf="!isInLoginPage && !isInTokenLoginPage && !isInUnsubscribePage && user" class="nav-sidebar-container"
  [ngClass]="{ 'is-mobile-view': isMobileView, 'process-mode': isOnProcessRoute && (isProcessActive || (isB2C && isOnPersonalView)) }">
  <div class="navSidebar-navItems-container" [ngClass]="{ 'is-mobile-view': isMobileView }">

    <button mat-icon-button *ngIf="isMobileView" class="sidebar-closeBtn" (click)="toggleMenu(false)">
      <mat-icon class="navIcon">close</mat-icon>
    </button>

    @if (isOnProcessRoute && (isProcessActive || (isB2C && isOnPersonalView))) {
      <button class="navItem back-button" (click)="toggleMenu(false)" [routerLink]="isOnPersonalView ? '/process' : '/allMotivationsView'">
        <mat-icon class="navIcon">arrow_back</mat-icon>
        <span class="navTxt">{{ "nav.backToMenu" | translate }}</span>
      </button>
      <mat-divider></mat-divider>
      <app-sidebar-process-steps (stepClicked)="onSidebarStepClicked()"></app-sidebar-process-steps>
    } @else {
      <button *ngIf="isFinishedDiscovery && isChatAllowed" class="navItem claire-navItem" routerLinkActive="navItem-active"
        (click)="toggleMenu(false)" [routerLink]="'/chat'">
        <img class="claire-icon" src="assets/common/claire.png" alt="Claire">
        <span class="navTxt claire-navTxt">{{ "nav.chat" | translate }}</span>
      </button>

      <div *ngIf="isFinishedDiscovery && isChatAllowed" class="nav-spacer"></div>

      <button *ngIf="user && !isB2C" class="navItem" routerLinkActive="navItem-active" (click)="toggleMenu(false)"
        [routerLink]="'/personalView'">
        <mat-icon class="navIcon">psychology_alt</mat-icon>
        <span class="navTxt">{{ "nav.myPersonalView" | translate }}</span>
      </button>

      <button *ngIf="user && hasPendingPulseCheck" class="navItem"
        (click)="navigateToPulseCheck()">
        <mat-icon class="navIcon pulseCheck-pending">notifications</mat-icon>
        <span class="navTxt pulseCheck-pending">{{ "nav.pulseView" | translate }}</span>
      </button>

      <div *ngIf="(user && !isB2C) || (user && hasPendingPulseCheck)" class="nav-spacer"></div>

      <button *ngIf="isStructuredProcessAllowed" class="navItem" routerLinkActive="navItem-active"
        (click)="toggleMenu(false)" [routerLink]="'/process'">
        <mat-icon class="navIcon">mediation</mat-icon>
        <span class="navTxt">{{ (isB2C ? "nav.structuredProcess" : "nav.structuredProcessB2B") | translate }}</span>
      </button>

      <div *ngIf="isStructuredProcessAllowed" class="nav-spacer"></div>

      <button *ngIf="isFinishedDiscovery && isTeamViewAllowed" class="navItem" routerLinkActive="navItem-active"
        (click)="toggleMenu(false)" [routerLink]="'/teamView'">
        <mat-icon class="navIcon">groups</mat-icon>
        <span class="navTxt">{{ "nav.myTeam" | translate }}</span>
      </button>

      <button *ngIf="isFinishedDiscovery && isTeamStateDashboardAllowed"
       class="navItem" routerLinkActive="navItem-active" (click)="toggleMenu(false)" [routerLink]="'/state'">
        <mat-icon class="navIcon">monitoring</mat-icon>
        <span class="navTxt">{{ "nav.state" | translate }}</span>
      </button>

      <mat-divider class="nav-divider"></mat-divider>

      <button *ngIf="isFinishedDiscovery" class="navItem" routerLinkActive="navItem-active" (click)="toggleMenu(false)"
        [routerLink]="'/allMotivationsView'">
        <mat-icon class="navIcon">Apps</mat-icon>
        <span class="navTxt">{{ "nav.allMotivations" | translate }}</span>
      </button>

      <button *ngIf="user && user.isReseller" class="navItem" routerLinkActive="navItem-active"
        (click)="toggleMenu(false)" [routerLink]="'/reseller'">
        <mat-icon class="navIcon">id_card</mat-icon>
        <span class="navTxt">{{ "nav.resellerView" | translate }}</span>
      </button>

      <button *ngIf="user && shouldPresentAdminPage" class="navItem" routerLinkActive="navItem-active"
        (click)="toggleMenu(false)" [routerLink]="'/admin'">
        <mat-icon class="navIcon">admin_panel_settings</mat-icon>
        <span class="navTxt">{{ "nav.adminView" | translate }}</span>
      </button>
    }

  </div>
</div>
